import moment from "moment"; // Importa Moment.js
class Paginado {
  constructor(
    db,
    collection,
    order,
    pageSize = 10,
    page = 1,
    condicion = null
  ) {
    this.db = db;
    this.collection = collection;
    this.pageSize = pageSize;
    this.page = page < 1 ? 1 : page;
    this.offset = (page - 1) * pageSize;
    this.order = order;
    this.condicion = condicion;
  }
  async data() {
    const collectionRef = this.db.collection(this.collection);
    let query = collectionRef.orderBy(this.order);
    if (Object.keys(this.condicion).length > 0) {
      query = query.where(
        this.condicion.campo,
        this.condicion.operador,
        this.condicion.valor
      );
    }
    let startAfterDoc = null;
    if (this.page > 1) {
      const startAfterSnapshot = await query
        .limit(this.pageSize * (this.page - 1))
        .get();
      const lastDoc = startAfterSnapshot.docs[startAfterSnapshot.size - 1];
      startAfterDoc = lastDoc;
    }

    const snapshot = await query
      .startAfter(startAfterDoc)
      .limit(this.pageSize)
      .get();

    const registros = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      creado: moment(doc.data().creado).format("YYYY-MM-DD HH:mm:ss"),
    }));
    const total = (await collectionRef.get()).size;
    const paginas = Math.ceil(total / this.pageSize);
    console.log(registros, total, paginas);

    return { registros, total, paginas };
  }
}

export default Paginado;
